import { analytics } from 'utils/analytics';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';

export function sendLoyaltyRegistartionBannerClickEvent() {
  analytics.sendEvent('GA:clickButton', {
    elementType: 'block',
    elementBlock: 'header', // блок, в котором расположен элемент
    elementName: 'headerAccount', // условное обозначение
    elementText: 'Оформить карту лояльности',
  });
}

export const onBasketClickCb = () => {
  analytics.sendEvent('GA:click', {
    name: 'basket', // название элемента
    position: 'header', // блок, в котором расположен элемент
  });
};

export const sendShowLoyaltyRegistrationModalEvent = (mfName: string) => {
  analytics.sendEvent('GA:show', {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: `Выберите свою карту и копите баллы / modal / ${mfName}`,
    elementText: 'Выберите свою карту и копите баллы',
  });
};

export const sendChooseCardEvent = (keycardType: EKeycardType) => {
  const text = keycardType === EKeycardType.HOME ? 'individual_card' : 'profi_card';

  const event = {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: text,
  };

  analytics.sendEvent('GA:clickButton', event);
};

export const sendYourCardCompleteEvent = (keycardType: EKeycardType) => {
  const card = keycardType === EKeycardType.HOME ? 'individual_card' : 'profi_card';

  const event = {
    elementType: 'block',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: `Ваша карта готова / ${card}`,
  };

  analytics.sendEvent('GA:show', event);
};

export const sendGetPromoCheckboxEvent = (value: boolean) => {
  const textValue = value ? 'Да' : 'Нет';

  const event = {
    elementType: 'button',
    elementBlock: 'modal',
    elementName: 'Выберите свою карту и копите баллы / modal',
    elementText: `Хочу получать промокоды и рекламные предложения / ${textValue}`,
  };

  analytics.sendEvent('GA:clickButton', event);
};
